import React from 'react';
import { TouchableOpacity } from 'react-native';
import { IconSvg } from 'src/assets';
import { LocationProps } from 'src/common/api/response';

import { formatDate } from 'src/common/utils/DateHelper';
import { Container, RegularText, Row, SizedBox } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics } from 'src/themes/Metrics';

export const TripListHeaderTitle = ({
  onPress,
  origin,
  destination,
  date,
  passenger,
}: {
  onPress: () => void;
  origin?: LocationProps;
  destination?: LocationProps;
  date?: any;
  passenger?: number;
}) => {
  return (
    <TouchableOpacity activeOpacity={0.8} onPress={onPress}>
      <Container align="center">
        <Row>
          <RegularText style={{ paddingRight: metrics.medium }} color={AppColors.white} fontWeight="bold">
            {origin?.name}
          </RegularText>
          <IconSvg.HeaderPointer fill={AppColors.white} />
          <RegularText color={AppColors.white} fontWeight="bold">
            {destination?.name}
          </RegularText>
        </Row>
        <Row style={{ alignItems: 'center' }}>
          <Container marginRight={metrics.small}>
            <IconSvg.Person />
          </Container>
          <RegularText fontWeight="bold" color="white">
            {passenger} | {formatDate(date)}
          </RegularText>
          <SizedBox width="medium" />
          <IconSvg.ArrowDown fill={AppColors.white} />
        </Row>
      </Container>
    </TouchableOpacity>
  );
};
